import { useEffect } from 'react';
import './StatsLanding.css';

// Animate stats on scroll
const stats = {
   hoursSaved: '11',
   avgCostReduction: '26%',
   onTimeDeliveryRate: '98%',
   costsSaved: '$1,500,000+'
};

const observerOptions = {
   threshold: 0.5,
   rootMargin: '0px 0px -100px 0px'
};

const observer = new IntersectionObserver(function (entries) {
   entries.forEach(entry => {
      if (entry.isIntersecting) {
         const statItems = entry.target.querySelectorAll('.stat-item h2');
         statItems.forEach((item, index) => {
            const statKey = item.getAttribute('data-stat');
            const finalValue = stats[statKey];
            item.textContent = '0';

            setTimeout(() => {
               const isBigCurrency = statKey === 'costsSaved';
               const animationDuration = isBigCurrency ? 1000 : 2000;
               animateValue(item, 0, finalValue, animationDuration);
            }, index * 200);
         });
      }
   });
}, observerOptions);

function animateValue(element, start, endValue, duration) {
   if (typeof endValue === 'string' && endValue.includes('/')) {
      element.textContent = endValue;
      return;
   }

   let end;
   let formatAsCurrency = false;
   let suffix = '';

   if (typeof endValue === 'string' && endValue.startsWith('$')) {
      formatAsCurrency = true;

      // Detect if it ends with a '+'
      if (endValue.trim().endsWith('+')) {
         suffix = '+';
      }

      // Strip $ and commas only, keep + out of the parse
      end = parseInt(endValue.replace(/[\$,]/g, '').replace('+', ''), 10);
   } else if (typeof endValue === 'string') {
      const match = endValue.match(/^(\d+)([%+])?$/);
      if (match) {
         end = parseInt(match[1], 10);
         suffix = match[2] || '';
      } else {
         element.textContent = endValue;
         return;
      }
   } else {
      end = endValue;
   }

   const frameRate = 60;
   const totalFrames = Math.round((duration / 1000) * frameRate);
   const increment = (end - start) / totalFrames;
   let current = start;
   let frame = 0;

   function update() {
      current += increment;
      frame++;

      const displayValue = Math.floor(current);

      if (formatAsCurrency) {
         element.textContent = '$' + displayValue.toLocaleString() + suffix;
      } else {
         element.textContent = displayValue + suffix;
      }

      if (frame < totalFrames) {
         requestAnimationFrame(update);
      } else {
         // Snap to final value
         if (formatAsCurrency) {
            element.textContent = '$' + end.toLocaleString() + suffix;
         } else {
            element.textContent = end + suffix;
         }
      }
   }

   requestAnimationFrame(update);
}

const StatsLanding = () => {
   useEffect(() => {
      const statsSection = document.querySelector('.landing-page-stats');
      if (statsSection) {
         observer.observe(statsSection);
      }

      return () => {
         observer.disconnect();
      };
   }, []);

   return (
      <section className="landing-page-stats">
         <div className="stats-container">
            <div className="stat-item">
               <h2 data-stat="avgCostReduction">{stats.avgCostReduction}</h2>
               <p>Average cost reduction</p>
            </div>

            <div className="stat-item">
               <h2 data-stat="hoursSaved">{stats.hoursSaved}</h2>
               <p>Hours Saved Weekly</p>
            </div>

            <div className="stat-item">
               <h2 data-stat="onTimeDeliveryRate">{stats.onTimeDeliveryRate}</h2>
               <p>On-time delivery rate</p>
            </div>

            <div className="stat-item">
               <h2 data-stat="costsSaved">{stats.costsSaved}</h2>
               <p>Cost Savings</p>
            </div>
         </div>
      </section>
   );
};

export default StatsLanding;
